var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contracts-show-view"
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.isSuccessfullyLoaded) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.contract.name))]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-container"
  }, [_c('div', {
    staticClass: "action-buttons"
  }, [_c('link-button', {
    attrs: {
      "to": {
        name: 'edit-contract',
        params: {
          id: _vm.contract.id
        }
      },
      "icon": "pencil"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.edit')) + "\n        ")]), _vm._v(" "), _c('link-button', {
    attrs: {
      "to": {
        name: 'contract-revisions',
        params: {
          id: _vm.contract.id
        }
      },
      "icon": "future"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.editRevisions')) + "\n        ")]), _vm._v(" "), _c('common-button', {
    attrs: {
      "type": "danger",
      "icon": "trash"
    },
    on: {
      "click": _vm.deleteContractWhenConfirmed
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.delete')) + "\n        ")])], 1), _vm._v(" "), (_vm.hasActiveRevision) ? _c('div', {
    staticClass: "active-revision-indicator"
  }, [_c('icon', {
    attrs: {
      "name": "check"
    }
  }), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.$t('hints.activeRevision')) + " ")])], 1) : _vm._e()]), _vm._v(" "), _c('mini-gallery', {
    attrs: {
      "record": _vm.contract
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.attributes')))]), _vm._v(" "), _c('attribute-table', {
    attrs: {
      "data": _vm.contract,
      "fields": ['contractNumber', 'provider', 'contractDuration', 'insertedAt', 'updatedAt']
    }
  }, [_c('template', {
    slot: "provider"
  }, [_c('provider-name', {
    attrs: {
      "name": _vm.contract.provider
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "contractDuration"
  }, [(_vm.contract.contractDuration) ? _c('duration', {
    attrs: {
      "value": _vm.contract.contractDuration
    }
  }) : _c('text-placeholder')], 1), _vm._v(" "), _c('template', {
    slot: "insertedAt"
  }, [_c('timeago', {
    attrs: {
      "since": _vm.contract.insertedAt,
      "auto-update": 60
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "updatedAt"
  }, [_c('timeago', {
    attrs: {
      "since": _vm.contract.updatedAt,
      "auto-update": 60
    }
  })], 1)], 2)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ac0b2df","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Contracts/ShowView.vue
// module id = 2003
// module chunks = 0